const SourceDomain = 'https://oss-prod.moshontek.com/webH5/'
class CommonUtil {
    isInApp = (agent) => {
        return agent.includes('Mology Cam')
    }
    getSourceDomain = () => {
        return SourceDomain
    }
}

export default new CommonUtil()